import { useEffect } from "react";

import EbayUnlistedTable from "../../components/ebayListings/unlistedTable/EbayUnlistedTable";
import { UnlistedTableStats } from "../../components/ebayListings/unlistedTable/Stats/UnlistedTableStats";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useCategories from "../../data/useCategories";

export default function EbayUnlisted() {
  const { setInfo } = usePageNameContext();
  const { categories } = useCategories();

  useEffect(() => {
    setInfo({
      name: "eBay Unlisted Items",
      desc: "View and manage parts that aren't listed on eBay",
    });
  }, []);

  useEffect(() => { }, [categories.isLoading]);

  if (categories.isLoading) return <LoadingWheel />;

  return (
    <div className="flex flex-col gap-y-4 mt-4">
      <UnlistedTableStats />

      <EbayUnlistedTable
        categories={categories.data?.data}
      />
    </div>
  )
}
